import { render, staticRenderFns } from "./tsetting.vue?vue&type=template&id=2c33c9fa&scoped=true&"
import script from "./tsetting.vue?vue&type=script&lang=js&"
export * from "./tsetting.vue?vue&type=script&lang=js&"
import style0 from "./tsetting.vue?vue&type=style&index=0&id=2c33c9fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c33c9fa",
  null
  
)

export default component.exports